import React, { Component } from 'react';
import ClientCaptcha from "react-client-captcha";


class ClientCaptchaComponent extends Component {
  constructor(props) {
    super(props);
} 

render() {
    return <ClientCaptcha 
    captchaCode={code => this.props.setCaptcha(code)} 
    />;
  }
}

export default ClientCaptchaComponent;